import { render, staticRenderFns } from "./CreditNoteRetrieve.vue?vue&type=template&id=71840b76"
import script from "./CreditNoteRetrieve.vue?vue&type=script&lang=js"
export * from "./CreditNoteRetrieve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports